






























































































































































































































































import {
	addDays,
	addHours,
	differenceInHours,
	differenceInMinutes,
	format,
	isSameDay,
	isValid,
	parse,
	startOfDay,
	startOfHour,
	addMinutes,
	setMinutes,
	setHours,
} from 'date-fns';
import Vue from 'vue';
import { required } from 'vuelidate/lib/validators';
import Component, { mixins } from 'vue-class-component';
import moment from 'moment'
import Flatpickr from 'vue-flatpickr-component';
import {
	mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import LocationSelector from '@/components/LocationSelector.vue';
import FormInput from '@/components/ui/FormInput.vue';
import FormInputTime from '@/components/ui/FormInputTime.vue';
import FormInputWithIcon from '@/components/ui/FormInputWithIcon.vue';
import FormMixin from '@/mixins/formMixin';
import Reservation from '@/models/Reservation';
import { getOr, getOrString, getOrZero } from '@/utilities/helpers';

function isValidDate(value: any) {
	return isValid(moment(value).toDate());
}

function checkInAfterToday(value: any, vm: any) {
	return differenceInMinutes(moment(vm.reservation.start_date).toDate(), new Date()) >= 1;
}

function checkInBeforeCheckout(value: any, vm: any) {
	return differenceInMinutes(moment(vm.reservation.end_date).toDate(), moment(vm.reservation.start_date).toDate()) > 30;
}

const DatesFormSetup = Vue.extend({
	components: {
		Flatpickr,
		FormInput,
		FormInputTime,
		FormInputWithIcon,
		LocationSelector,
	},
	props: {
		buttonLabel: String,
		checkInLabel: String,
		checkoutLabel: String,
		datesLabel: String,
		locationLabel: String,
		max_date: Number,
		lockLocation: {
			type: Boolean,
			default: false,
		},
		promoLabel: { type: String, default: '' },
		showPromo: { type: String, default: 'always' },
	},
	computed: {
		...mapState(['isLoading']),
		...mapState('location', ['locations']),
		...mapState('reservation', ['preload', 'reservation']),
		...mapGetters('location', ['corporatePromo', 'hasLocation', 'location', 'settings']),
		promo_code() {
			return this.reservation.promo_code;
		},

	},
	methods: {
		...mapMutations('reservation', [
			'clearQuote',
			'clearQuotes',
			'setEndDate',
			'setPromoCode',
			'setStartDate',
		]),
		...mapActions('analytics', [
			'action',
		]),
	},
	watch: {
		promo_code() {
			this.$store.commit('clearErrors');
			this.clearQuote();
			this.clearQuotes();
		},
		location() {
			this.reservation.promo_code = this.settings.prefill_promo_code_field;
		},
	},
	validations: {
		checkInDate: {
			required,
			minDate: checkInAfterToday,
			validDate: isValidDate,
		},
		checkInTime: {
			required,
		},
		checkoutDate: {
			minDate: checkInBeforeCheckout,
			required,
			validDate: isValidDate,
		},
		checkoutTime: {
			required,
		},
	},
});

@Component
export default class DatesForm extends mixins(DatesFormSetup, FormMixin) {
	// Props
	public buttonLabel!: string;
	public checkInLabel!: string;
	public checkoutLabel!: string;
	public locationLabel!: string;
	public lockLocation!: boolean;
	public promoLabel!: string;
	public showPromo!: string;

	// Data
	public dateConfig = {
		altFormat: 'm/d/Y',
		altInput: true,
		dateFormat: 'Y-m-d',
	};

	public maxTargetDate: Date | null = null;
	public dateFormat: string = 'YYYY-MM-DD HH:mm:00';
	public dayFormat: string = 'YYYY-MM-DD';
	public hasPromo: boolean = false;
	public now = new Date();
	public onReservationsPage = false;
	public reload = false;
	public timeFormat: string = 'HH:mm';

	// State
	public isLoading!: boolean;
	public locations!: Locations.Location[];
	public preload!: boolean;
	public reservation!: Reservation;

	// Getters
	public corporatePromo!: string;
	public hasLocation!: boolean;
	public location!: Locations.Location;

	// Mutations
	public clearQuote!: () => void;
	public clearQuotes!: () => void;
	public setEndDate!: (date: string) => void;
	public setPromoCode!: (promo: string) => void;
	public setStartDate!: (date: string) => void;


	public get startOperations() {
		return this.settings.start_hours_of_operation ? this.settings.start_hours_of_operation : '00:00';
	}

	public get endOperations() {
		return this.settings.end_hours_of_operation ? this.settings.end_hours_of_operation : '00:00';
	}


	public get checkInLabelComputed(): string | null {
		if (this.settings && this.settings.check_in_label) {
			return this.settings.check_in_label;
		}

		return this.checkInLabel || null;
	}

	public get checkoutLabelComputed(): string | null {
		if (this.settings && this.settings.check_out_label) {
			return this.settings.check_out_label;
		}

		return this.checkoutLabel || null;
	}

	public get locationLabelComputed(): string | null {
		if (this.settings && this.settings.location_select_label) {
			return this.settings.location_select_label;
		}

		return this.locationLabel || null;
	}

	public get checkInDate(): string {
		let date = moment(this.reservation.start_date).toDate();

		if (isValid(date)) {
			return format(date, this.dateFormat);
		}

		date = addDays(addHours(startOfHour(new Date()), 1), 1);
		if (this.settings.default_start_date_adjustment) {
			date = addHours(startOfHour(new Date()), 1);
		}
		if (this.settings.default_reservation_start_time) {
			const [hours, minutes] = this.settings.default_reservation_start_time.split(':');
			date = setHours(date, +hours);
			date = setMinutes(date, +minutes);
		}

		while (date < this.today) {
			date = addDays(date, 1);
		}

		return format(date, this.dateFormat);
	}

	public get time_interval_adjustment(): boolean {
		// !! will give false on false, null, or any other false value, and true on true values
		return !!this.settings.time_interval_adjustment;
	}

	public set checkInDate(value: string) {
		const checkInDate = format(moment(value).toDate(), this.dayFormat);
		this.setStartDate(`${checkInDate} ${this.checkInTime}`);
		this.testDates();
		this.enableReload();
	}

	public get checkoutDate(): string {
		let date = moment(this.reservation.end_date).toDate();
		if (!isValid(date)) {
			let startDate = moment(this.checkInDate).toDate();
			startDate = isValid(startDate) ? startDate : new Date();
			date = addHours(startDate, getOr(1, 'default_reservation_length', this.settings));

			if (this.settings.default_reservation_end_time) {
				date = addHours(startDate, getOr(0, 'default_reservation_length', this.settings));
				const [hours, minutes] = this.settings.default_reservation_end_time.split(':');
				date = setHours(date, +hours);
				date = setMinutes(date, +minutes);
			}
			while (date < this.minDateTime) {
				date = addHours(date, 1);
			}
		}

		return format(date, this.dateFormat);
	}

	public set checkoutDate(value: string) {
		const checkoutDate = format(moment(value).toDate(), this.dayFormat);

		this.setEndDate(`${checkoutDate} ${this.checkoutTime}`);
		this.enableReload();
	}

	public get checkInTime(): string {
		return format(moment(this.checkInDate).toDate(), this.timeFormat);
	}

	public set checkInTime(value: string) {
		const startDate = format(moment(this.checkInDate).toDate(), this.dayFormat);
		this.setStartDate(`${startDate} ${value}`);
	}

	public get checkoutTime(): string {
		return format(moment(this.checkoutDate).toDate(), this.timeFormat);
	}

	public set checkoutTime(value: string) {
		const endDate = format(moment(this.checkoutDate).toDate(), this.dayFormat);
		this.setEndDate(`${endDate} ${value}`);
	}

	public get hasLabels() {
		return this.checkInLabelComputed || this.checkoutLabelComputed;
	}

	public get isTooLong(): boolean {
		return differenceInHours(
			moment(this.checkoutDate).toDate(),
			moment(this.checkInDate).toDate(),
		) > this.maxReservationHours;
	}

	public get minDateTime(): Date {
		return addHours(moment(this.checkInDate).toDate(), getOr(1, 'required_stay_length', this.settings));
	}

	public get maxReservationHours(): number {
		let max = 2160; // 90 days
		if (this.settings) {
			max = +getOr(max, 'max_stay_length', this.settings);
		}

		return max;
	}

	// Returns back a nicely formatted maximum stay length in days and hours
	public get maxReservationLength(): string {
		const max = this.maxReservationHours;
		const days = Math.floor(max / 24);
		const hours = max % 24;

		let output = '';
		if (days > 0) {
			output += `${days} day(s)`;
		}

		if (days > 0 && hours > 0) {
			output += ' and ';
		}

		if (hours > 0) {
			output += ` ${hours} hour(s)`;
		}

		return output;
	}

	public get minStartTime(): Date {
		return addMinutes(this.now, getOrZero('advanced_booking_time', this.settings));
	}

	public get promoError(): string {
		const error = this.$store.state.formErrors.find((item: any) => item.field === 'promo_code' || item.field === 'voucher');

		return error ? error.msg : '';
	}

	public get settings(): Locations.Settings {
		return this.$store.getters['location/settings'];
	}

	public get today(): Date {
		return startOfDay(addMinutes(new Date(), getOrZero('advanced_booking_time', this.settings)));
	}

	public mounted() {
		if (this.max_date > 0) {
			this.maxTargetDate = addDays(new Date(), this.max_date);
		}

		if (getOrString('reservation.promo_code', this.$store.state.reservation)) {
			this.togglePromoCode();
		}

		if (this.preload || this.reservation.preload) {
			this.submit();
		}

		this.reservation.promo_code = this.reservation.promo_code || this.settings.prefill_promo_code_field;
		this.onReservationsPage = window.location.href.indexOf('/reservation/') >= 0;
	}

	public enableReload() {
		this.reload = true;
		this.$store.commit('clearErrors');
		this.clearQuote();
		this.clearQuotes();
	}

	public testDates() {
		const startDate = moment(this.reservation.start_date).toDate();
		let endDate = moment(this.reservation.end_date).toDate();

		if (this.max_date > 0) {
			this.maxTargetDate = addDays(startDate, this.max_date);
		}

		if (startDate >= endDate) {
			if (isSameDay(startDate, endDate)) {
				endDate = addHours(startDate, 1);
			} else if (this.settings.default_reservation_length) {
				endDate = addHours(startDate, this.settings.default_reservation_length);
			} else {
				endDate = addDays(startDate, 1);
			}

			this.checkoutDate = format(endDate, this.dateFormat);
			this.checkoutTime = format(endDate, this.timeFormat);
		} else if (startDate < endDate && this.settings.due_date_range_enforcement && this.settings.default_reservation_length) {
			endDate = addHours(startDate, this.settings.default_reservation_length);

			this.checkoutDate = format(endDate, this.dateFormat);
			this.checkoutTime = format(endDate, this.timeFormat);
		}
	}

	public togglePromoCode() {
		this.$store.dispatch('googleEvents/bookingShowPromoCode', {});
		this.hasPromo = !this.hasPromo;
	}

	public submit() {
		this.$v.$touch();

		if (this.$v.$invalid) {
			return;
		}
		this.$store.dispatch('googleEvents/fetchReservationPriceQuotes', {
			startDate: this.reservation.start_date,
			endDate: this.reservation.end_date,
			promoCode: this.reservation.promo_code ? this.reservation.promo_code : '',
		});
		this.reload = false;
		this.$store.commit('clearErrors');
		this.clearQuote();

		this.$emit('submit', {
			...this.reservation.quoteRequest,
			location: this.location.codeID,
		});
	}

	public updatePromo(promo: string) {
		this.setPromoCode(promo);
		this.$store.commit('clearErrors');
	}
}
